import moment from 'moment';

export const formatDuration = (miliseconds, precision = 0) => {
  if (miliseconds === 0) {
    return '0s';
  }
  if (!miliseconds) return;

  const duration = moment.duration(miliseconds);
  const minutes = duration.asMinutes();
  const seconds = duration.asSeconds();
  if (minutes >= 60) {
    return `${Math.floor(minutes / 60)}h ${(minutes % 60).toFixed(precision)}m`;
  } else if (minutes >= 1) {
    return `${minutes.toFixed(precision)}m`;
  } else if (seconds) {
    return `${seconds.toFixed(precision)}s`;
  }
};

export const formatPlayerTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secondsRemainder = Math.round(seconds) % 60;
  const paddedSeconds = `0${secondsRemainder}`.slice(-2);
  return `${minutes}:${paddedSeconds}`;
};

export const formatDate = (
  firebaseTimestamp,
  format = 'ddd, D MMM',
) => {
  if (!firebaseTimestamp) {
    return undefined;
  }
  if (typeof firebaseTimestamp === 'number') {
    return moment.unix(firebaseTimestamp).format(format);
  }
  return moment
    .unix(firebaseTimestamp._seconds || firebaseTimestamp.seconds)
    .format(format);
};

export const fromNow = (firebaseTimestamp) => {
  if (typeof firebaseTimestamp === 'number') {
    return moment.unix(firebaseTimestamp / 1000).fromNow();
  }
  return moment
    .unix(firebaseTimestamp._seconds || firebaseTimestamp.seconds)
    .fromNow();
};

// Create an array of weekday and month names
const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const formatIsoToDate = (iso) => {
  const date = new Date(iso);
  return `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]} `;
};

export const formatIsoToTime = (iso) => {
  const date = new Date(iso);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const formatTimeToMMMSS = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(3, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const parseTimeToSeconds = (timeStr) => {
  if (!timeStr) return 0;
  const [minutes, seconds] = timeStr.split(':').map(Number);
  return (minutes * 60) + seconds;
};

export default formatDuration;
